{
  "paymentInformation": "Maksutiedot",
  "paymentReferences": "Viitteet ja tilinumerot",
  "paymentHistory": "Maksuhistoria",
  "currentMonth": "Kuluva kuukausi",
  "invoices": "Laskut",
  "itemisation": "Laskuerittely",
  "payer": "Maksaja",
  "dueDate": "Eräpäivä",
  "sum": "Summa",
  "sumTotal": "Yhteensä",
  "remittances": "Maksut",
  "refund": "Palautus",
  "transfer": "Siirto",
  "withheldFrom": {
    "securityDeposit": "Pidätys vakuudesta",
    "depositVoucher": "Pidätys maksusitoumuksesta",
    "rooFee": "Pidätys asumisoikeusmaksusta"
  },
  "paidDate": "Maksettu",
  "noTargets": "Ei laskurivejä",
  "creditNote": "Hyvitys",
  "noRemittances": "Ei maksuja",
  "arrearTotal": "Maksettava yhteensä",
  "advanceTotal": "Ennakkoa yhteensä",
  "arrearTotalForMonth": "Maksettavaa {{month}}",
  "advanceTotalForMonth": "Ennakkoa {{month}}",
  "neutralTotal": "Yhteensä",
  "saldo": "Saldo",
  "paymentTypeCategory": {
    "chargesForUtilities": "Käyttökorvaus",
    "rent": "Vuokra",
    "residenceCharge": "Käyttövastike",
    "rightOfOccupancyDeposit": "Asumisoikeusmaksu",
    "securityDeposit": "Vakuusmaksu",
    "interest": "Korko",
    "generic": "Yleinen",
    "rightOfOccupancyNewDevelopmentDeposit": "Uudisrakentamisen ASO-maksu"
  },
  "paymentsBeneficiary": "Saaja",
  "referenceNumber": "Laskujen viitenumero",
  "noAccountData": "Tilitiedot puuttuvat",
  "errors": {
    "failedToLoadPaymentInfo": "Maksutietojen lataaminen epäonnistui",
    "failedToLoadPaymentHistory": "Maksuhistorian lataaminen epäonnistui",
    "paymentsAccessDenied": "Sinulla ei ole riittäviä oikeuksia nähdä tämän sopimuksen maksutietoja."
  }
}
